import xiazuanConfig from "./drillDownConfig"
import turf from "turf"
import mapboxgl from "mapbox-gl"
let that = "";
class drillDown {
  /*构造函数*/
  constructor() {
    this.zoomIng = false;
    /*地图实例*/
    /*个性化配置项,在激活下钻传参时候可配置options中的所有项目*/
    this.options = {
      initLocation: true, /*初始化是否定位到指定行政区*/

      initCenter: "", /*初始定位中心*/
      initAreaCode: "", /*初始化高亮行政区代码*/
      initZoom: "", /*初始定位级别*/

      initBounds: "", /*初始定位范围*/
      initPadding: "", /*初始定位Padding*/
      initMaxZoom: "", /*初始定位限制最大放大级别*/

      initHilight: true, /*是否初始化高亮初始行政区*/
      ifHlightBorder: true, /*是否高亮边框*/
      ifFilterPoint:false,/*下钻是否同时过滤掉下级行政区的点图层*/

      xiazuanToLevel: "", /*配置下钻的最低级别,比如村级不需要下钻,这里就配置为村的level数*/
      queryTime: 8000, /*下钻后查询下一行政区图层的信息,如果网络很慢图层加载需要时间,这里默认给8000ms,超过8000ms图层未加载出来则停止查询*/
      cyXizauanZoomLevel: 13.1, /*点击村域,下钻后的级别,如点击村域下钻后需要显示地块,则此处可设置地块的minZoom保证地块能显示,默认13.1,如传"fit",则定位以显示村范围为主*/
      cyMaxZoomLevel:13,/*村域下钻蒙层最大级别*/
      cyFitMaxZoom:"",/*点击村域下钻为fit时,设置最大放大级别*/
      cyFitPadding:""/*点击村域下钻为fit时,设置padding*/
    };
    this.addLayerIds = [],
      this.lastLevelObj = "", /*激活下钻初始级别信息*/
      this.clickCallBack = "",/*下钻点击callback,点击下钻图层后立刻执行*/
      this.zoomEndCallBack = "", /*激活下钻功能模块的点击回调函数, 点击的下一行政区图层加载完毕后执行*/
      this.zoomBack = "", /*激活下钻功能模块的缩放回调函数(缩放超出当前范围)*/
      this.zoomBackInsideLevel = "", /*激活下钻功能模块的缩放回调函数(缩放未超出当前范围)*/
      this.zoomStopMethod = "",/*下钻地图停止后触发*/
      this.curClickObj = "", /*当前点击的行政区信息对象*/
      this.isClick = false, /*标记是否点击*/
      this.curHilightBorder = "", /*当前高亮边框的图层ID*/
      this.nextClickObj = "" /*当前下一级别行政区信息*/
    this.ptArrResult = "";/*点击下钻返回的点图层查询参数*/
    this.areaArrResult = "";/*点击下钻返回的面图层查询参数*/
    //this.active(mapC, optionsC, zoomEndCallBack, zoomBack, zoomBackInsideLevel);
  }

  /**
   * 1.接口:
   *    active:激活下钻功能;
   *    inActive:卸载下钻功能;
   */

  /**
   * @param mapC  地图实例
   * @param optionsC  个性化配置参数
   * @param zoomEndCallBack 下钻的点击后zoomend回调函数
   * @param clikCallBack 下钻的点击立刻执行的回调函数
   * @param zoomBack  下钻缩放回调(超过当前行政区级别的缩放)
   * @param zoomBackInsideLevel 下钻缩放回调(未超过当前行政区级别的缩放)
   * @param zoomStopMethod 下钻缩放停止后触发的回调函数
   * @returns {string}
   */
  /*active(mapC, optionsC = {},eventConfigPar, clikCallBack ,zoomEndCallBack, zoomBack, zoomBackInsideLevel,zoomStopMethod) {*/
  active(mapC, optionsC = {},eventConfigPar = {}) {
    that = this;
    if (!mapC || !mapC.getLayer) {
      console.warning("未传入地图实例,下钻初始化失败");
      return "请传入地图实例";
    }
    this.map = mapC;
    this.clickCallBack = eventConfigPar.clickEvent || "";
    this.zoomEndCallBack = eventConfigPar.clickEndEvent || "";
    this.zoomBack = eventConfigPar.zoomCrossLevel || "";
    this.zoomBackInsideLevel = eventConfigPar.zoomNotCrossLevel || "";
    this.zoomStopMethod = eventConfigPar.zoomStop || "";
    this.lastLevelObj = this.getCurrentLevelObj();
    /*处理个性化配置*/
    if ( typeof(optionsC) === "object"  &&  !(optionsC instanceof Array)  ) {
      this.options =  Object.assign({},this.options,optionsC);/*将传入的配置属性值覆盖默认值*/
    } else {
      console.log("options参数格式错误");
    }
    this.addXiazuanLayer();/*添加下钻所需图层*/
    this.mapOn();/*绑定下钻图层事件*/
    if (this.options.initLocation) {/*是否初始化定位*/
      this.initLocation();
    };
    if (this.options.initHilight) {/*是否初始化高亮初始行政区*/
      this.initHilightXzq();
    }
  }

  inActive() {
    /*解除事件*/
    xiazuanConfig.xzqLayer.forEach(item => {
      this.map.off("mousemove", item.layer_fill, this.Mousemove);
      this.map.off("mouseout", item.layer_fill, this.Mouseout);
      this.map.off("click", item.layer_fill, this.xiazuanLayerClick);
      this.map.off("zoomend", this.xiazuanZoomend);
    });

    /*清除下钻添加的图层*/
    this.addLayerIds.forEach(item => {
      if (this.map.getLayer(item)) {
        this.map.removeLayer(item);
      }
    });
    /*重置下钻参数*/
    this.addLayerIds = [];
    this.map = "";
    this.options = {
      /*个性化配置*/
      initCenter: "", /*初始定位中心*/
      initAreaCode: "", /*初始化高亮行政区代码*/
      initZoom: "", /*初始定位级别*/
      initBounds: "", /*初始定位范围*/
      initPadding: "", /*初始定位Padding*/
      initMaxZoom: "", /*初始定位限制最大放大级别*/
      initHilight: true, /*是否初始化高亮初始行政区*/
      initLocation: true, /*初始化是否定位到指定行政区*/
      ifHlightBorder: true, /*是否高亮边框*/
      ifFilterPoint:false,/*下钻是否同时过滤掉下级行政区的点图层*/
      xiazuanToLevel: "", /*配置下钻的最低级别,比如村级不需要下钻,这里就配置为村的level数*/
      queryTime: 8000, /*下钻后查询下一行政区图层的信息,如果网络很慢图层加载需要时间,这里默认给8000ms,超过8000ms图层未加载出来则停止查询*/
      cyXizauanZoomLevel: 13.1, /*点击村域,下钻后的级别,如点击村域下钻后需要显示地块,则此处可设置地块的minZoom保证地块能显示,默认13.1,如传"fit",则定位以显示村范围为主*/
      cyMaxZoomLevel:13,/*村域下钻蒙层最大级别*/
      cyFitMaxZoom:"",/*点击村域下钻为fit时,设置最大放大级别*/
      cyFitPadding:"",/*点击村域下钻为fit时,设置padding*/
    };
    this.zoomIng = false;
    this.zoomEndCallBack = "";
    this.clickCallBack = "";
    this.zoomBack = "";
    this.zoomBackInsideLevel = "";
    this.zoomStopMethod = "",
      this.lastLevelObj = "";
    this.isClick = false;
    this.curHilightBorder = "";
    this.curClickObj = "";
    this.nextClickObj = "";
    this.ptArrResult = "";/*点击下钻返回的点图层查询参数*/
    this.areaArrResult = "";/*点击下钻返回的面图层查询参数*/

  }

  /**
   * 下钻图层点击事件
   * @param e
   * @constructor
   */
  xiazuanLayerClick(e) {
    that.isClick = true;
    let layerId = e.features[0].layer.id;
    /*获取当前点击的基本的行政区的信息对象*/
    let layerObj = xiazuanConfig.xzqLayer.find(function (item) {
      return (item.layer_fill === layerId) ? item : null;
    });
    layerObj.curFeature = e.features;
    /*将点击的要素存到当前点击的行政区信息对象里供后面使用*/
    layerObj.curClickObj = e;
    /*将点击的回调参数存到当前点击的行政区信息对象里供后面使用*/
    that.curClickObj = layerObj;
    if (that.options.ifHlightBorder) {/*如果配置的是下钻并高亮边框*/
      that.hilightBorder(e.features[0].properties.qhdm);
      /*高亮点击的行政区的边框*/
    }
    let lv = layerObj.level;
    /*获取下一级别行政区的信息对象*/
    let nextLayerObj = xiazuanConfig.xzqLayer.find(function (item) {
      return (item.level === (lv + 1)) ? item : null;
    });
    that.nextClickObj = nextLayerObj || "";

    /*执行下钻点击的回调函数*/
    if(that.clickCallBack){
      that.clickCallBack(e,layerObj,nextLayerObj);
    }

    if (nextLayerObj) {
      /*过滤下级行政区相关图层*/
      that.setMapFilter(nextLayerObj.layerId, ['==', 'sjxzqdm', e.features[0].properties.qhdm]);
      that.setMapFilter(nextLayerObj.layer_fill, ['==', 'sjxzqdm', e.features[0].properties.qhdm]);
      that.setMapFilter(nextLayerObj.layer_ht, ['==', 'a', "b"]);
      that.setMapFilter(nextLayerObj.layer_bk, ['==', 'a', 'b']);
      if(that.options.ifFilterPoint){
        that.setMapFilter(nextLayerObj.ptLayerId, ['==', 'sjxzqdm', e.features[0].properties.qhdm]);
      }
      if(nextLayerObj.additionalLayers instanceof Array  && nextLayerObj.additionalLayers.length > 0){/*配置有其他图层也进行同等条件的过滤*/
        nextLayerObj.additionalLayers.forEach(item => {
          that.setMapFilter(item,  ['==', 'sjxzqdm', e.features[0].properties.qhdm]);
        });
      }
    }

    let e_bound = turf.bbox(e.features[0].geometry);
    let bounds = new mapboxgl.LngLatBounds(new mapboxgl.LngLat(e_bound[0], e_bound[1]), new mapboxgl.LngLat(e_bound[2], e_bound[3]));
    /*点击村用fitBounds定位,其余用Center加Zoom组合定位保证能定位到下一行政区的级别*/
    if (layerObj.levelName != "村") {
      that.map.setCenter(bounds.getCenter());
      that.map.zoomTo(nextLayerObj.minzoom + 0.1);
    } else {
      if (that.options.cyXizauanZoomLevel != "fit") {
        that.map.setCenter(bounds.getCenter());
        that.map.zoomTo(that.options.cyXizauanZoomLevel);
      } else {
        let filter = {};
        if (that.options.cyFitPadding) {
          filter.padding = parseFloat(that.options.cyFitPadding);
        }
        if (that.options.cyFitMaxZoom) {
          filter.maxZoom = parseFloat(that.options.cyFitMaxZoom);
        }
        that.map.fitBounds(bounds, filter);
      }
      /*隐藏村域的鼠标识别图层,过滤村域图层*/
      that.setMapFilter(layerObj.layerId, ['==', 'qhdm', e.features[0].properties.qhdm]);
      that.setMapFilter(layerObj.layer_fill, ['==', 'a', 'b']);
      that.setMapFilter(layerObj.layer_ht, ['==', 'a', 'b']);
    }
  }

  /**
   * 鼠标移动事件
   * @param e
   * @constructor
   */
  Mousemove(e) {
    if (e && e.features[0]) {
      let layerId = e.features[0].layer.id;
      let layerObj = xiazuanConfig.xzqLayer.find(function (ele) {
        return (ele.layer_fill === layerId) ? ele : null;
      });
      if (layerObj) {
        that.setMapFilter(layerObj.layer_ht, ['==', 'qhdm', e.features[0].properties.qhdm]);
      }
    }
  }

  /**
   * 鼠标移出事件
   * @param e
   * @constructor
   */
  Mouseout(e) {
    xiazuanConfig.xzqLayer.forEach(item => {
      that.setMapFilter(item.layer_ht, ['==', 'qhdm', "jiazhi"]);
    });
  };

  /*确定下级图层加载出来之后执行回调*/
  getMapZoomEnd() {
    return new Promise((resolve, reject) => {
      if (this.nextClickObj) {
        /*如果图中没有该资源则停止*/
        if (!this.map.getSource(this.nextClickObj.sourceId_pt)) {
          console.log("地图中没有id为" + this.nextClickObj.sourceId_pt + "的资源");
          reject();
          return;
        }
        let setTime = "";
        let interval = setInterval(() => {
          /*下一级别图层加载完认为地图停止,可以执行查询操作*/
          if (this.map.isSourceLoaded(this.nextClickObj.sourceId_pt) && this.map.isSourceLoaded(this.nextClickObj.sourceId) ) {
            clearInterval(interval);
            clearTimeout(setTime);
            resolve();
          }
          ;
        }, 100);
        /*超时没结果不再查询*/
        setTime = setTimeout(() => {
          clearInterval(interval);
          console.log(`${this.nextClickObj.sourceId_pt}资源加载慢,查询超时`);
        }, this.options.queryTime);
      } else {
        resolve();
      }
    });
  }

  /*地图的zoomend事件*/
  xiazuanZoomend(e) {
    if(that.zoomIng){
      return
    }else{
      that.zoomIng = true;
    }
    that.getMapZoomEnd().then(
      (res) => {
        that.zoomIng = false;
        /*在这里加下钻停止的回调*/
        if(that.zoomStopMethod){
          try{
            that.zoomStopMethod();
          }catch (err){
            console.log()
          }
        }

        if (that.isClick) {/*如果是点击产生的zoomend事件*/
          setTimeout(() => {/*这里延迟50ms执行,给that.curClickObj赋值留出时间*/
            /*重置标记*/
            that.isClick = false;
            let pt_features = [];/*点图层查询结果*/
            let area_features = [];/*面图层查询结果*/
            if (that.nextClickObj) {
              pt_features = that.map.querySourceFeatures(that.nextClickObj.sourceId_pt, {
                'sourceLayer': that.nextClickObj.sourceLayer_pt,
                'filter': ['==', 'sjxzqdm', that.curClickObj.curFeature[0].properties.qhdm]
              });
              area_features = that.map.querySourceFeatures(that.nextClickObj.sourceId, {
                'sourceLayer': that.nextClickObj.sourceLayer,
                'filter': ['==', 'sjxzqdm', that.curClickObj.curFeature[0].properties.qhdm]
              });
            }
            that.lastLevelObj = that.getCurrentLevelObj();
            /*查询结果有重复,此处是去重,利用对象键值去重*/
            let objPt = {};
            let objArea = {};
            let ptArrResult = [];/*存储点层查询结果的去重结果*/
            let areaArrResult = [];/*存储面层查询结果的去重结果*/
            pt_features.forEach(item => {
              if(!objPt[item.properties.qhdm]){
                objPt[item.properties.qhdm] = true;
                ptArrResult.push(item);
              }
            });
            area_features.forEach(item => {
              if(!objArea[item.properties.qhdm]){
                objArea[item.properties.qhdm] = true;
                areaArrResult.push(item);
              }
            });

            /*全包括了所有参数, 调用模块可以各取所需,
              参数1:当前点击的行政区的点击返回参数和配置信息;
              参数2:点击行政区的下级所有行政区点要素集;
              参数3:点击行政区的下级所有行政区面要素集;
              */
            if (that.zoomEndCallBack) {
              that.zoomEndCallBack(that.curClickObj, ptArrResult, areaArrResult);
              /*将每次点击返回的参数存下来*/
              that.ptArrResult = ptArrResult;
              that.areaArrResult = areaArrResult;
            }
          },20)

        } else {/*如果是缩放产生的zoomend事件*/
          let nextLevelObj = that.getCurrentLevelObj();  // 获取缩放后图层级别信息
          if (that.lastLevelObj&&nextLevelObj) {          // 当缩放后缩放前图层级别信息同时存在时
              if (nextLevelObj.level === that.lastLevelObj.level) {
            /*    if (that.lastLevelObj.levelName.indexOf("村") > -1 && that.map.getZoom() < 13) {/!*村域缩放到小于13则显示村域的高亮图层*!/
                  /!*隐藏村域的鼠标识别图层,过滤村域图层*!/
                  that.setMapFilter(that.lastLevelObj.layerId, ['!=', 'qhdm', "jiazhi"]);
                  that.setMapFilter(that.lastLevelObj.layer_fill, ['!=', 'a', 'b']);
                }
                if (nextLevelObj.levelName.indexOf("村") > -1 && that.map.getZoom() >= 13) {/!*村域缩放到大于13则隐藏村域的识别和高亮图层*!/
                  /!*隐藏村域的鼠标识别图层,过滤村域图层*!/
                  that.setMapFilter(nextLevelObj.layer_fill, ['==', 'a', 'b']);
                  that.setMapFilter(nextLevelObj.layer_ht, ['==', 'a', "b"]);
                }*/
                if (that.zoomBackInsideLevel) { /*缩放,没超出当前行政区级别范围,返回参数为当前级别信息对象*/
                  that.zoomBackInsideLevel(that.lastLevelObj);
                }
              }
              if (nextLevelObj.level != that.lastLevelObj.level) {
                if (that.zoomBack) {/*缩放,超出当前行政区级别范围,返回参数为之前级别信息对象和当前级别信息对象*/
                  /*清空上次点击返回的参数*/
                  that.ptArrResult = "";
                  that.areaArrResult = "";
                  that.curClickObj = "";
                  /*=====================*/
                  that.setMapFilter(that.lastLevelObj.layerId, ["all"]);/*将下级行政区filter过滤条件重置*/
                  /*====================*/
                  that.zoomBack(that.lastLevelObj, nextLevelObj);
                }
              }
          }

          if(!that.curClickObj){                        // 缩放前图层级别信息存在时
            if (nextLevelObj) {
                 that.setMapFilter(nextLevelObj.layerId, ["all"]); /*将下级行政区filter过滤条件重置*/

              if (that.zoomBack) {/*缩放,超出当前行政区级别范围,返回参数为之前级别信息对象和当前级别信息对象*/
                // /*=====================*/
                // that.setMapFilter(that.lastLevelObj.layerId, ["all"]); /*将下级行政区filter过滤条件重置*/
                // /*====================*/
                // that.zoomBack(that.lastLevelObj, nextLevelObj);
                //2020.10.26 因原函数在that.lastLevelObj判断为空的情况下依然使用that.lastLevelObj，故修改如下
                 /*====================*/
                 that.zoomBack(nextLevelObj, nextLevelObj);
              }
            }
            if (!nextLevelObj){
              if (that.zoomBackInsideLevel) { /*缩放,没超出当前行政区级别范围,返回参数为当前级别信息对象*/
                that.zoomBackInsideLevel(that.lastLevelObj);
              }
            }
          }
          that.lastLevelObj = that.getCurrentLevelObj();
        }
      },
      (res) => {
        console.log("获取地图停止错误");
      },
    ).catch((err) => {
      console.log("获取地图停止异常");
      console.log(err);
    }).finally(() => {
      that.isClick = false;
    });
  };


  /**
   * 计算当前行政区级别的配置信息
   */
  getCurrentLevelObj() {
    let curZoom = this.map.getZoom();
    let currentLevelObj = xiazuanConfig.xzqLayer.find(function (item) {//根据当前行政级别取查找对应的行政区级别的资源
      return (item.minzoom < curZoom && item.maxzoom >= curZoom);
    });
    return currentLevelObj;
  }

  /**
   * 通过区划代码获取行政区级别
   * @param areaCode
   */
  getQhjbByQhdm(areaCode) {
    let curxzq = "";
    if (areaCode.toString().length == 1 || areaCode == 1) {// 如果长度是1，表示全国权限账户，
      curxzq = "全国";
    }
    if (areaCode.toString().length == 2) {
      curxzq = "省";
    }
    if (areaCode.toString().length == 4) {
      curxzq = "地市";
    }
    if (areaCode.toString().length == 6) {
      curxzq = "县";
    }
    if (areaCode.toString().length == 9) {
      curxzq = "乡镇";
    }
    if (areaCode.toString().length == 12) {
      curxzq = "村";
    }
    return curxzq;
  }

  /**
   * 高亮行政区边框
   * @param areaCode 区划代码
   */
  hilightBorder(areaCode) {
    if (this.curHilightBorder) {
      this.moveCurHilight();
      /*清除上一行政区高亮*/
    }
    let curxzq = this.getQhjbByQhdm(areaCode);
    let obj = "";
    if (curxzq === "全国") {
      obj = xiazuanConfig.qgConfig;
    } else {
      obj = xiazuanConfig.xzqLayer.find(function (func) {//根据当前行政级别取查找对应的行政区级别的资源
        return func.levelName === curxzq;
      });
    }
    this.curHilightBorder = obj.layer_bk;
    this.setMapFilter(obj.layer_bk, ["==", "qhdm", areaCode]);
  }

  /**
   *添加下钻所需的图层 (总共三种:
   *                      1.各级别行政区的fill层(透明的),用于查询图层数据;
   *                      2.各级别行政区的fill层,用于鼠标悬浮某行政区后高亮该行政区蒙层;
   *                      3.各级别行政区的line层,用于高亮该行政区的边框
   *                    );
   * @param
   */
  addXiazuanLayer() {
    let minLevel = "";
    if (this.options.xiazuanToLevel) {
      minLevel = this.options.xiazuanToLevel;
    }
    /*遍历地图图层的配置信息来添加相关图层*/
    for (let i = 0; i < xiazuanConfig.xzqLayer.length; i++) {
      let item = xiazuanConfig.xzqLayer[i];
      if (minLevel && item.level === minLevel) {
        break;
      }
      ;
      //1增加透明的fill图层用于查询
      if (!this.map.getLayer(item.layer_fill)) {
        this.map.addLayer({
          "id": item.layer_fill,
          "type": "fill",
          "source": item.sourceId,
          "source-layer": item.sourceLayer,
          "minzoom": item.minzoom,
          "maxzoom":  item.levelName === "村" ? this.options.cyMaxZoomLevel : item.maxzoom,
          "layout": {
            "visibility": "visible"
          },
          "paint": {
            "fill-opacity":0,
            /*"fill-color": "#627BC1",
            "fill-opacity": ["case",
              ["boolean", ["feature-state", "hover"], false],
              1,
              0
            ]*/
          },
        });
        this.addLayerIds.push(item.layer_fill);
      }
      ;
      //2增加高亮ht图层用于高亮行政区区域
      if (!this.map.getLayer(item.layer_ht)) {
        this.map.addLayer({
          "id": item.layer_ht,
          "type": "fill",
          "source": item.sourceId,
          "source-layer": item.sourceLayer,
          "minzoom": item.minzoom,
          "maxzoom": item.levelName === "村" ? this.options.cyMaxZoomLevel : item.maxzoom,
          "layout": {
            "visibility": "visible"
          },
          "paint": {
            "fill-color": item.overFillColor || xiazuanConfig.defaultOverFillColor || "#0127EB",
            "fill-opacity": parseFloat(item.overFillOpacity) || xiazuanConfig.defaultOverFillOpacity || 0.2,
          },
          "filter": ["==", "qhdm", "jiazhi"]
        });
        this.addLayerIds.push(item.layer_ht);
      }
      ;
      //3增加边界bk图层用于高亮行政区边界
      if (!this.map.getLayer(item.layer_bk)) {
        this.map.addLayer({
          "id": item.layer_bk,
          "type": "line",
          "source": item.sourceId,
          "source-layer": item.sourceLayer,
          "minzoom": item.minzoom,
          "layout": {
            "visibility": "visible"
          },
          "paint": {
            "line-color": item.borderColor || xiazuanConfig.defaultBorderColor || "#dea6de",
            "line-opacity": parseFloat(item.borderOpacity) || parseFloat(xiazuanConfig.defaultBorderOpacity) || 1,
            "line-width": parseFloat(item.borderWidth) || parseFloat(xiazuanConfig.defaultBorderWidth) || 4,
          },
          "filter": ["==", "qhdm", ""]
        });
        this.addLayerIds.push(item.layer_bk);
      }
    };

    /*添加国家级别行政区边框高亮图层*/
    let qgLayerObj = xiazuanConfig.qgConfig;
    /*国家级别行政区配置信息*/
    if (!this.map.getLayer(qgLayerObj.layer_bk)) {
      this.map.addLayer({
        "id": qgLayerObj.layer_bk,
        "type": "line",
        "source": qgLayerObj.sourceId,
        "source-layer": qgLayerObj.sourceLayer,
        "minzoom": qgLayerObj.minzoom,
        "layout": {
          "visibility": "visible"
        },
        "paint": {
          "line-color":  qgLayerObj.borderColor || xiazuanConfig.defaultBorderColor || "#dea6de",
          "line-opacity":parseFloat(qgLayerObj.borderOpacity) || parseFloat(xiazuanConfig.defaultBorderOpacity) || 1,
          "line-width": parseFloat(qgLayerObj.borderWidth) || parseFloat(xiazuanConfig.defaultBorderWidth) || 4
        },
        "filter": ["==", "qhdm", ""]
      });
      this.addLayerIds.push(qgLayerObj.layer_bk);
    }
  }

  /**
   * 初始高亮行政区
   */
  initHilightXzq() {
    if (this.options.initAreaCode) {
      this.hilightBorder(this.options.initAreaCode);
      /*初始高亮行政区代码*/
    } else {
      console.log("初始高亮行政区边框失败:请配置初始行政区编码initAreaCode");
      return "初始高亮行政区边框失败:请配置初始行政区编码initAreaCode";
    }
  }

  /**
   * 初始定位
   */
  initLocation() {
    let options = this.options;
    if (options && options.initLocation) {
      /*初始化定位,setCenter定位优先*/
      if (options.initCenter) {/*有initCenter,使用setCenter定位*/
        if (!options.initZoom && !options.initAreaCode) {
          console.log("初始定位失败:请配置初始定位级别或初始定位行政区代码");
          return "初始定位失败:请配置初始定位级别或初始定位行政区级别名称";
        } else if (options.initZoom) {/*如果配置了initZoom,以此为主,否则进行下面的根据行政区最大级别-0.1来确定zoom的值*/
          this.map.setCenter(options.initCenter);
          this.map.zoomTo(options.initZoom);
        } else if (options.initAreaCode) {
          let qhjb = this.getQhjbByQhdm(options.initAreaCode);
          /*根据行政区代码获取行政区级别*/
          if (!qhjb) {
            console.log("初始定位失败:配置的initAreaCode不符合规范,请检查intiAreaCode");
            return "初始定位失败:配置的initAreaCode不符合规范,请检查intiAreaCode";
          }
          let layerObj = ""
          if (qhjb === "全国") {
            layerObj = xiazuanConfig.qgConfig;
          } else {
            layerObj = xiazuanConfig.xzqLayer.find(function (item) {
              return (item.levelName === qhjb) ? item : null;
            });
          }
          if (!layerObj) {
            console.log("初始定位失败:配置的行政区名称在配置文件中无对应项");
            return "初始定位失败:配置的行政区名称在配置文件中无对应项";
          } else if (!layerObj.maxzoom) {
            console.log("初始定位失败:配置的行政区名称在配置文件中无maxzoom配置");
            return "初始定位失败:配置的行政区名称在配置文件中无maxzoom配置";
          } else {
            this.map.setCenter(options.initCenter);
            this.map.zoomTo(layerObj.maxzoom - 0.1);
          }
        }
      } else if (options.initBounds) {
        let filter = {padding: 0};
        if (options.initPadding) {
          filter.padding = parseFloat(options.initPadding);
        }
        if (options.initMaxZoom) {
          filter.maxZoom = parseFloat(options.initMaxZoom);
        }
        this.map.fitBounds(options.initBounds, filter);
      } else {
        console.log("请配置初始定位相关信息");
        return "请配置初始定位相关信息";
      }
    }
  }

  /**
   *绑定下钻相关事件
   * @param
   */
  mapOn() {
    xiazuanConfig.xzqLayer.forEach((item, index) => {
      /*绑定下钻相关图层事件*/
      this.map.on("mousemove", item.layer_fill, this.Mousemove);//高亮当前鼠标划过的行政区
      this.map.on("mouseout", item.layer_fill, this.Mouseout);//去掉高亮当前鼠标划过的行政区
      this.map.on("click", item.layer_fill, this.xiazuanLayerClick);//识别图层点击事件
      this.map.on("zoomend", this.xiazuanZoomend);//绑定下钻功能的zoomend事件
    });
  }

  /**
   * 过滤图层
   * @param layerId
   * @param filter
   */
  setMapFilter(layerId, filter) {
    if (this.map && this.map.getLayer(layerId)) {
      this.map.setFilter(layerId, filter);
    }
  }

  /**
   * 取消当前高亮边框
   */
  moveCurHilight() {
    if (this.curHilightBorder) {
      this.setMapFilter(this.curHilightBorder, ["==", "qhdm", "jiazhi"]);
    }
  }

}


export default drillDown;



// WEBPACK FOOTER //
// ./src/common/drillDown/drillDown.js